/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { ConfirmationOutgoingInternal } from '../model';
// @ts-ignore
import { ConfirmationPreview } from '../model';
// @ts-ignore
import { PaginatedConfirmationOutgoingInternalList } from '../model';
/**
 * OrganisationBookingConfirmationOutgoingApi - axios parameter creator
 * @export
 */
export const OrganisationBookingConfirmationOutgoingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This can only occur when a Confirmations status == OPEN and it is the latest Confirmation against the Booking
         * @summary Cancel a confirmation
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} confirmationId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationCancelCreate: async (bookingId: string, buyerOrgId: string, confirmationId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingConfirmationCancelCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingConfirmationCancelCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'confirmationId' is not null or undefined
            assertParamExists('orgBookingConfirmationCancelCreate', 'confirmationId', confirmationId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/confirmation/{confirmation_id}/cancel`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"confirmation_id"}}`, encodeURIComponent(String(confirmationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A Confirmation can only be created when the status of the Booking == OPEN
         * @summary Creates a Confirmation and sends out an SMS to the recipient of the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationCreate: async (bookingId: string, buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingConfirmationCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingConfirmationCreate', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/confirmation`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Retrieve a list of all the Confirmations associated with the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationList: async (bookingId: string, buyerOrgId: string, aaSource?: string, page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingConfirmationList', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingConfirmationList', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/confirmation`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This includes a preview of the SMS body, the recipients, and Confirmation against the latest Booking version
         * @summary Preview of a new Confirmation
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationPreviewRetrieve: async (bookingId: string, buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingConfirmationPreviewRetrieve', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingConfirmationPreviewRetrieve', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/confirmation/preview`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This can only occur when a Confirmations status == OPEN and it is the latest Confirmation against the Booking
         * @summary Resend a Confirmation SMS
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} confirmationId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationResendCreate: async (bookingId: string, buyerOrgId: string, confirmationId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingConfirmationResendCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingConfirmationResendCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'confirmationId' is not null or undefined
            assertParamExists('orgBookingConfirmationResendCreate', 'confirmationId', confirmationId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/confirmation/{confirmation_id}/resend`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"confirmation_id"}}`, encodeURIComponent(String(confirmationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single Confirmation
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} confirmationId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationRetrieve: async (bookingId: string, buyerOrgId: string, confirmationId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingConfirmationRetrieve', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingConfirmationRetrieve', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'confirmationId' is not null or undefined
            assertParamExists('orgBookingConfirmationRetrieve', 'confirmationId', confirmationId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/confirmation/{confirmation_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"confirmation_id"}}`, encodeURIComponent(String(confirmationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationBookingConfirmationOutgoingApi - functional programming interface
 * @export
 */
export const OrganisationBookingConfirmationOutgoingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationBookingConfirmationOutgoingApiAxiosParamCreator(configuration)
    return {
        /**
         * This can only occur when a Confirmations status == OPEN and it is the latest Confirmation against the Booking
         * @summary Cancel a confirmation
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} confirmationId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingConfirmationCancelCreate(bookingId: string, buyerOrgId: string, confirmationId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationOutgoingInternal>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingConfirmationCancelCreate(bookingId, buyerOrgId, confirmationId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A Confirmation can only be created when the status of the Booking == OPEN
         * @summary Creates a Confirmation and sends out an SMS to the recipient of the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingConfirmationCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationOutgoingInternal>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingConfirmationCreate(bookingId, buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Retrieve a list of all the Confirmations associated with the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingConfirmationList(bookingId: string, buyerOrgId: string, aaSource?: string, page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedConfirmationOutgoingInternalList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingConfirmationList(bookingId, buyerOrgId, aaSource, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This includes a preview of the SMS body, the recipients, and Confirmation against the latest Booking version
         * @summary Preview of a new Confirmation
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingConfirmationPreviewRetrieve(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingConfirmationPreviewRetrieve(bookingId, buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This can only occur when a Confirmations status == OPEN and it is the latest Confirmation against the Booking
         * @summary Resend a Confirmation SMS
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} confirmationId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingConfirmationResendCreate(bookingId: string, buyerOrgId: string, confirmationId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingConfirmationResendCreate(bookingId, buyerOrgId, confirmationId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single Confirmation
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} confirmationId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingConfirmationRetrieve(bookingId: string, buyerOrgId: string, confirmationId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationOutgoingInternal>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingConfirmationRetrieve(bookingId, buyerOrgId, confirmationId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationBookingConfirmationOutgoingApi - factory interface
 * @export
 */
export const OrganisationBookingConfirmationOutgoingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationBookingConfirmationOutgoingApiFp(configuration)
    return {
        /**
         * This can only occur when a Confirmations status == OPEN and it is the latest Confirmation against the Booking
         * @summary Cancel a confirmation
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} confirmationId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationCancelCreate(bookingId: string, buyerOrgId: string, confirmationId: string, aaSource?: string, options?: any): AxiosPromise<ConfirmationOutgoingInternal> {
            return localVarFp.orgBookingConfirmationCancelCreate(bookingId, buyerOrgId, confirmationId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * A Confirmation can only be created when the status of the Booking == OPEN
         * @summary Creates a Confirmation and sends out an SMS to the recipient of the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<ConfirmationOutgoingInternal> {
            return localVarFp.orgBookingConfirmationCreate(bookingId, buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Retrieve a list of all the Confirmations associated with the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationList(bookingId: string, buyerOrgId: string, aaSource?: string, page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedConfirmationOutgoingInternalList> {
            return localVarFp.orgBookingConfirmationList(bookingId, buyerOrgId, aaSource, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * This includes a preview of the SMS body, the recipients, and Confirmation against the latest Booking version
         * @summary Preview of a new Confirmation
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationPreviewRetrieve(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<ConfirmationPreview> {
            return localVarFp.orgBookingConfirmationPreviewRetrieve(bookingId, buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * This can only occur when a Confirmations status == OPEN and it is the latest Confirmation against the Booking
         * @summary Resend a Confirmation SMS
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} confirmationId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationResendCreate(bookingId: string, buyerOrgId: string, confirmationId: string, aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orgBookingConfirmationResendCreate(bookingId, buyerOrgId, confirmationId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single Confirmation
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} confirmationId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfirmationRetrieve(bookingId: string, buyerOrgId: string, confirmationId: string, aaSource?: string, options?: any): AxiosPromise<ConfirmationOutgoingInternal> {
            return localVarFp.orgBookingConfirmationRetrieve(bookingId, buyerOrgId, confirmationId, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgBookingConfirmationCancelCreate operation in OrganisationBookingConfirmationOutgoingApi.
 * @export
 * @interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCancelCreateRequest
 */
export interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCancelCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCancelCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCancelCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCancelCreate
     */
    readonly confirmationId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCancelCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingConfirmationCreate operation in OrganisationBookingConfirmationOutgoingApi.
 * @export
 * @interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCreateRequest
 */
export interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCreate
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingConfirmationList operation in OrganisationBookingConfirmationOutgoingApi.
 * @export
 * @interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationListRequest
 */
export interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationListRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationList
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationList
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationList
     */
    readonly aaSource?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationList
     */
    readonly pageSize?: number
}

/**
 * Request parameters for orgBookingConfirmationPreviewRetrieve operation in OrganisationBookingConfirmationOutgoingApi.
 * @export
 * @interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationPreviewRetrieveRequest
 */
export interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationPreviewRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationPreviewRetrieve
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationPreviewRetrieve
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationPreviewRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingConfirmationResendCreate operation in OrganisationBookingConfirmationOutgoingApi.
 * @export
 * @interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationResendCreateRequest
 */
export interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationResendCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationResendCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationResendCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationResendCreate
     */
    readonly confirmationId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationResendCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingConfirmationRetrieve operation in OrganisationBookingConfirmationOutgoingApi.
 * @export
 * @interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationRetrieveRequest
 */
export interface OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationRetrieve
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationRetrieve
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationRetrieve
     */
    readonly confirmationId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationRetrieve
     */
    readonly aaSource?: string
}

/**
 * OrganisationBookingConfirmationOutgoingApi - object-oriented interface
 * @export
 * @class OrganisationBookingConfirmationOutgoingApi
 * @extends {BaseAPI}
 */
export class OrganisationBookingConfirmationOutgoingApi extends BaseAPI {
    /**
     * This can only occur when a Confirmations status == OPEN and it is the latest Confirmation against the Booking
     * @summary Cancel a confirmation
     * @param {OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCancelCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingConfirmationOutgoingApi
     */
    public orgBookingConfirmationCancelCreate(requestParameters: OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCancelCreateRequest, options?: any) {
        return OrganisationBookingConfirmationOutgoingApiFp(this.configuration).orgBookingConfirmationCancelCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.confirmationId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A Confirmation can only be created when the status of the Booking == OPEN
     * @summary Creates a Confirmation and sends out an SMS to the recipient of the Booking
     * @param {OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingConfirmationOutgoingApi
     */
    public orgBookingConfirmationCreate(requestParameters: OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationCreateRequest, options?: any) {
        return OrganisationBookingConfirmationOutgoingApiFp(this.configuration).orgBookingConfirmationCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Retrieve a list of all the Confirmations associated with the Booking
     * @param {OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingConfirmationOutgoingApi
     */
    public orgBookingConfirmationList(requestParameters: OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationListRequest, options?: any) {
        return OrganisationBookingConfirmationOutgoingApiFp(this.configuration).orgBookingConfirmationList(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This includes a preview of the SMS body, the recipients, and Confirmation against the latest Booking version
     * @summary Preview of a new Confirmation
     * @param {OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationPreviewRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingConfirmationOutgoingApi
     */
    public orgBookingConfirmationPreviewRetrieve(requestParameters: OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationPreviewRetrieveRequest, options?: any) {
        return OrganisationBookingConfirmationOutgoingApiFp(this.configuration).orgBookingConfirmationPreviewRetrieve(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This can only occur when a Confirmations status == OPEN and it is the latest Confirmation against the Booking
     * @summary Resend a Confirmation SMS
     * @param {OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationResendCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingConfirmationOutgoingApi
     */
    public orgBookingConfirmationResendCreate(requestParameters: OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationResendCreateRequest, options?: any) {
        return OrganisationBookingConfirmationOutgoingApiFp(this.configuration).orgBookingConfirmationResendCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.confirmationId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Get the details of a single Confirmation
     * @param {OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingConfirmationOutgoingApi
     */
    public orgBookingConfirmationRetrieve(requestParameters: OrganisationBookingConfirmationOutgoingApiOrgBookingConfirmationRetrieveRequest, options?: any) {
        return OrganisationBookingConfirmationOutgoingApiFp(this.configuration).orgBookingConfirmationRetrieve(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.confirmationId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
